<div class="profiledialog">
    <div mat-dialog-title class="d-flex align-items-center justify-content-between">
        <span class="fw-600">Competency Overview</span>
        <span><i class="fa fa-times model_close cursor-pointer" (click)="closeDialog()"></i></span>
    </div>
    <div class="container px-3 pt-3">
        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>{{ competency }}</span>
                </ng-template>
                <div class="row m-0 matbodycontent">
                    <div class="col-md-6">
                        <div class="label_section">
                            <div class="label_title">Competency</div>
                            <div class="label_value">{{ competency }}</div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="label_section">
                            <div class="label_title">SubCompetency</div>
                            <div class="label_value">{{ subCompetencyName }}</div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="label_section">
                            <div class="label_title">Vertical Expertise</div>
                            <div class="pl-4 row m-0">
                                <div class="col-md-6" *ngFor="let domain of employee?.domains">
                                    <div class="label_value label_list">{{domain}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="label_section">
                            <div class="label_title">Area of Expertise</div>
                            <div class="pl-4 row m-0">
                                <div class="col-md-6" *ngFor="let service of employee?.serviceAreas">
                                    <div class="label_value label_list">
                                        {{service?.serviceArea}} - {{service?.expYears}} years {{service?.expMonths}}
                                        Months
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="label_section">
                            <div class="label_title">Primary Skills</div>
                            <div class="pl-4 row m-0">
                                <div class="col-md-6" *ngFor="let data of employee?.primarySkills">
                                    <div class="label_value label_list">{{data?.skill}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="label_section">
                            <div class="label_title">Secondary Skills</div>
                            <div class="pl-4 row m-0">
                                <div class="col-md-6" *ngFor="let data of employee?.secondarySkills">
                                    <div class="label_value label_list">{{data?.skill}}</div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12">
                        <div class="label_section">
                            <div class="label_title">Status</div>
                            <div class="label_value">{{ employeeProfileStatus }}</div>
                        </div>
                    </div>
                </div>
            </mat-tab>

        </mat-tab-group>
    </div>
    <!-- <mat-tab-group>
            <mat-tab *ngFor="let tab of tabs; let index = index">
              <ng-template mat-tab-label>{{ tab.title }}</ng-template>
              <div>{{ tab.content }}</div>
            </mat-tab>
          </mat-tab-group> -->
    <div class="col-md-12 mt-2">
        <a href="javascript:void(0)" (click)="closeDialog();navigateToEmployeeDetails()" class="view-more-link">View more</a>
    </div>
</div>